export default "__VITE_ASSET__3XvEUOwU__";